module.exports = __webpack_public_path__ + "img/group_tip.6dda35d7.gif";